import { useCallback } from 'react';
import { debounce } from 'src/utils/helpers.utils';

export const useDebouncedCallback = (...props: Parameters<typeof debounce>) =>
  useCallback(debounce(...props), [props[0]]);
